import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/product-feed")({
  component: lazyRouteComponent(() => import("./-pages/admin.product-feed")),
  head: () => ({
    meta: [
      { title: "Product Feed · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
